export interface MenuItem {
  title: string
  icon?: string
  link?: string
  isHeader?: boolean
  hasBadge?: boolean
}

interface State {
  menus: MenuItem[]
}

const defaultState: State = {
  menus: []
}

const state: State = Object.assign({}, defaultState)

const mutations = {
  resetState(state: State) {
    const s = defaultState
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },

  setMenus(state: State, menus: MenuItem[]) {
    state.menus = menus
  }
}

const actions = {}

const getters = {
  menus: (state: State): MenuItem[] => state.menus
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
